export default __webpack_public_path__ + "static/media/annex9.1950b7ec.png";